import { Persona } from './persona';
import { TipoGenericoRimovibile } from './tipologiche/tipo-generico-rimovibile';

export class BeneficiarioPagamento {
  tipoBeneficiarioPagamento: TipoGenericoRimovibile;
  persona: Persona;
  idParent: string;
  categoria: string;
}
